



























































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import PrettyCheck from 'pretty-checkbox-vue/check';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import {
  getLive,
  updateLive,
  updateLiveModuleStatus,
} from '@/api/index';

const Setting = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { route } = useRouter();

    const errorModal = ref(null);
    const successModal = ref(null);
    const agenda = ref(1);
    const agendaShowChoices = [
      'ปิดการแสดงผล',
      'แสดงกำหนดการ ณ ปัจจุบัน',
      'แสดงกำหนดการทั้งงาน (Highlight)',
      'แสดงกำหนดการทั้งงาน (Non Highlight)',
    ];
    const feature = reactive({
      enablePoll: { value: false, label: 'แสดงเมนูโหวต', description: '* แสดง Vote ในหน้าถ่ายทอดสด' },
      enableQuestion: { value: false, label: 'แสดงเมนูถามตอบ', description: '* แสดง Q&A ในหน้าถ่ายทอดสด' },
      enableChat: { value: false, label: 'แสดงเมนูสนทนา', description: '* แสดง Chat ในหน้าถ่ายทอดสด' },
      enableStore: { value: false, label: 'แสดงเมนูร้านค้า', description: '* แสดง Store ในหน้าถ่ายทอดสด' },
    });
    const textFeature = reactive({
      iframe: '',
    });

    async function updateStatus(name: string, status: boolean) {
      const result = await updateLiveModuleStatus(
        route.value.params.liveId,
        name,
        !status,
      );
      if (result !== 'error') (feature as any)[name].value = !status;
      else (errorModal.value as any).compose();
    }

    /* eslint-disable */
    async function updateAgendaShowType(type: number | string) {
      const result = await updateLiveModuleStatus(
        route.value.params.liveId,
        'showAgenda',
        type,
      );
      if (agenda.value === type) return '';
      else if (result !== 'error') agenda.value = (type as any);
      else (errorModal.value as any).compose();
    }
    /* eslint-enable */

    async function updateTextFeatures() {
      await updateLive(route.value.params.liveId, { iframe: textFeature.iframe });
      (successModal.value as any).compose({ action: 'บันทึก' });
    }

    onMounted(async () => {
      const result = await getLive(route.value.params.liveId);
      (feature.enableChat as any).value = result.enable_chat;
      (feature.enableQuestion as any).value = result.enable_question;
      (feature.enablePoll as any).value = result.enable_poll;
      (feature.enableStore as any).value = result.enable_store;
      textFeature.iframe = result.iframe;
      agenda.value = result.show_agenda;
    });

    return {
      errorModal,

      agendaShowChoices,
      feature,
      agenda,

      updateStatus,
      updateAgendaShowType,

      textFeature,
      successModal,
      updateTextFeatures,
    };
  },
});

export default Setting;
